// extracted by mini-css-extract-plugin
module.exports = {"couponToast":"CouponToast_couponToast__OmKEl","image":"CouponToast_image__QyM25","message":"CouponToast_message__VDM9F"};